/*
 * -----------------------------------------------------------------------------
 *  Lucom Interaction Platform
 *  (C) Lucom GmbH, Erkrath. All rights reserved.
 * -----------------------------------------------------------------------------
 */

/**
 * Get the DOM Document hosting the LIP form, wither the browser's main Document
 * (i.e. window.document) or the shadow root when runnin in embedded mode
 *
 * @returns {ShadowRoot|Document}
 */
export function getDocument() {
    const elements = window.document.getElementsByTagName("lucom-wci-form");
    if (elements.length > 0) {
        const shadowHost = elements[0];
        return (shadowHost && shadowHost.shadowRoot) || window.document;
    }

    return window.document;
}
